module.exports = __webpack_public_path__ + "img/application.fce7d7c2.svg";